
import {ColumnType} from "antd/es/table"
import {Button, Input, InputRef, Space} from "antd"
import {SearchOutlined} from "@ant-design/icons"
import React, {useRef} from "react"
import {useTheme} from "react-jss"
import {GlobalToken} from "antd/es/theme/interface"
import { PartnerDTO } from "../../types/partner/PartnerDTO"

export const useSearchColumn = () => {
    const searchInput = useRef<InputRef>(null)
    const theme = useTheme<GlobalToken>()

    const handleReset = (clearFilters: () => void, confirm: () => void) => {
        clearFilters()
        confirm()
    }

    const getColumnSearchProps = (placeholder: string, type?: string): ColumnType<PartnerDTO> => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (
            <div style={{padding: 8}} onKeyDown={e => e.stopPropagation()}>
                <Input
                    placeholder={placeholder}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => confirm()}
                    style={{marginBottom: 8, display: "block"}}
                    type={type}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{width: 90}}
                    >
                        Искать
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters, confirm)}
                        size="small"
                        style={{width: 90}}
                    >
                        Сбросить
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={close}
                    >
                        Закрыть
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{color: filtered ? theme.colorPrimary : undefined}} />
        ),
        onFilterDropdownOpenChange: visible => {
            if (visible) setTimeout(() => searchInput.current?.select(), 100)
        }
    })
    return {getColumnSearchProps}
}
